import React, { Component } from 'react';
import { connect } from 'react-redux';
import LinearProgress from '@mui/material/LinearProgress';
import LOOKUP from 'constants/lookup';
import { mapDbTopSellers } from 'utils/mappers';
import Button from 'screens/components/basic/Button';
import DashDialog from 'screens/components/basic/DialogHeaderDashboard'
import GenericTable from 'screens/components/advanced/GenericTable';
import { getTopSellers } from 'actions/DashboardActions';
class TopSellers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dayActive: false,
            weekActive: false,
            monthActive: true
        }

        this.clickTopSellersDay = this.clickTopSellersDay.bind(this)
        this.clickTopSellersWeek = this.clickTopSellersWeek.bind(this)
        this.clickTopSellersMonth = this.clickTopSellersMonth.bind(this)
    }

    clickTopSellersDay = () => {
        this.props.handleTopSellersFilter('day')
        this.setState({
            dayActive: true,
            weekActive: false,
            monthActive: false
        })
    }

    clickTopSellersWeek = () => {
        this.props.handleTopSellersFilter('week')
        this.setState({
            dayActive: false,
            weekActive: true,
            monthActive: false
        })
    }

    clickTopSellersMonth = () => {
        this.props.handleTopSellersFilter('month')
        this.setState({
            dayActive: false,
            weekActive: false,
            monthActive: true
        })
    }

    render() {
        const { topSellers } = this.props;

        return (
            <div id="chart3" className="item col-4-p-0 ml-3">
                <DashDialog
                    text="Top Performing Employees"
                    link="/report/budtender-average-sales"
                    classicClass="bg-ClassicRed"
                    isReport={true}
                    refreshAction={() => this.props.getTopSellers({ branchId: this.props.branchId, periodFilter: 'month' })} />
                <div className="employee_height position-relative">
                    {
                        this.props.loading
                            ?
                            <LinearProgress variant="indeterminate" />
                            :
                            <React.Fragment>
                                <div>

                                    {
                                        mapDbTopSellers(topSellers).length > 0 ?

                                            <GenericTable
                                                className="table_center no-header"
                                                multiSelectable={false}
                                                enableSelectAll={false}
                                                selectable={false}
                                                columns={LOOKUP.employee.dashBoardTable}
                                                rows={mapDbTopSellers(topSellers)}
                                            />
                                            :
                                            <div className="table_msg">
                                                <h2 >NO EMPLOYEES TO DISPLAY</h2>
                                            </div>
                                    }
                                </div>
                                <div className="days_btns">
                                    <Button name="buttonSave"
                                        type="dashboardButton"
                                        className={this.state.dayActive ? "db-btns btn-selected btnNewBrandPOS noPaddingBtn" : "db-btns btnNewBrandGray noPaddingBtn"}
                                        label="Day"
                                        onTouchTap={this.clickTopSellersDay}
                                    />

                                    <Button name="buttonSave"
                                        type="dashboardButton"
                                        className={this.state.weekActive ? "db-btns btn-selected btnNewBrandPOS noPaddingBtn" : "db-btns btnNewBrandGray noPaddingBtn"}
                                        label="Week"
                                        onTouchTap={this.clickTopSellersWeek}
                                    />

                                    <Button name="buttonCancel"
                                        type="dashboardButton"
                                        className={this.state.monthActive ? "db-btns btn-selected btnNewBrandPOS noPaddingBtn" : "db-btns btn-space btnNewBrandGray noPaddingBtn"}
                                        label="Month"
                                        onTouchTap={this.clickTopSellersMonth}
                                    />
                                </div>
                            </React.Fragment>
                    }
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        loading: state.common.dbTopSellersCall > 0,
        branchId: state.common.branchId
    }
}

function mapDispatchToProps(dispatch){
    return {
        getTopSellers: (model) => dispatch(getTopSellers(model, true)),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(TopSellers);